import LegalPageLayout, {
  LegalList,
  LegalSection,
} from '../../components/feature/LegalPageLayout';
import {
  getLegalMissingFields,
  LEGAL_ADDRESS,
  LEGAL_BUSINESS_NAME,
  LEGAL_DIC,
  LEGAL_EMAIL,
  LEGAL_ICO,
  LEGAL_PHONE,
  LEGAL_REGISTER_ENTRY,
  LEGAL_SITE_NAME,
  LEGAL_SITE_URL,
  LEGAL_UPDATED_AT,
} from '../../lib/legalInfo';

export default function PrivacyPage() {
  const missingFields = getLegalMissingFields();

  return (
    <LegalPageLayout
      badge="Ochrana osobných údajov"
      badgeIcon="ri-shield-check-line"
      title="Ochrana osobných údajov"
      lead="Táto stránka vysvetľuje, aké osobné údaje spracúvam, na aký účel, na akom právnom základe a aké práva Vám ako dotknutej osobe patria."
      supporting="Ide o informačný dokument pre návštevníkov webu a osoby, ktoré odošlú dopyt alebo nadviažu komunikáciu cez kontaktný formulár, e-mail alebo WhatsApp."
      lastUpdated={LEGAL_UPDATED_AT}
    >
      {missingFields.length ? (
        <LegalSection title="Údaje na doplnenie pred finálnym zverejnením">
          <p>
            Aby bol tento dokument úplný aj z pohľadu identifikačných povinností,
            je ešte potrebné doplniť:
          </p>
          <LegalList items={missingFields} />
        </LegalSection>
      ) : null}

      <LegalSection title="1. Prevádzkovateľ">
        <p>
          Prevádzkovateľom osobných údajov je <strong>{LEGAL_SITE_NAME}</strong>, názov
          živnosti <strong>{LEGAL_BUSINESS_NAME}</strong>, IČO <strong>{LEGAL_ICO}</strong>,
          DIČ <strong>{LEGAL_DIC}</strong>.
        </p>
        <p>
          Kontakt: <strong>{LEGAL_EMAIL}</strong>, tel. <strong>{LEGAL_PHONE}</strong>,
          web <strong>{LEGAL_SITE_URL}</strong>.
        </p>
        <p>
          {LEGAL_ADDRESS ? (
            <>
              Miesto podnikania: <strong>{LEGAL_ADDRESS}</strong>.
            </>
          ) : (
            <>
              Miesto podnikania bude doplnené po overení údajov.
            </>
          )}{' '}
          {LEGAL_REGISTER_ENTRY ? (
            <>
              Zápis v registri: <strong>{LEGAL_REGISTER_ENTRY}</strong>.
            </>
          ) : (
            <>Údaj o zápise v registri bude doplnený po overení.</>
          )}
        </p>
      </LegalSection>

      <LegalSection title="2. Aké údaje spracúvam">
        <p>V závislosti od toho, ako s webom pracujete, môžem spracúvať najmä:</p>
        <LegalList
          items={[
            'identifikačné a kontaktné údaje z dopytu: meno a priezvisko, e-mail, telefón, firma alebo projekt',
            'obsah komunikácie: typ dopytu, rozpočet, text správy a následná e-mailová alebo WhatsApp komunikácia',
            'technické údaje súvisiace s používaním webu, najmä IP adresa, logy servera, základné bezpečnostné záznamy a údaje potrebné pre fungovanie stránky',
            'údaje o návštevnosti a používaní webu, ale len v rozsahu analytických cookies, s ktorými ste výslovne súhlasili',
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Účely a právne základy spracúvania">
        <p>
          Osobné údaje spracúvam len v rozsahu potrebnom na konkrétny účel a na
          príslušnom právnom základe podľa čl. 6 GDPR.
        </p>
        <LegalList
          items={[
            'vybavenie dopytu a predzmluvná komunikácia: čl. 6 ods. 1 písm. b) GDPR',
            'plnenie zmluvy a následná projektová komunikácia, ak dôjde k spolupráci: čl. 6 ods. 1 písm. b) GDPR',
            'plnenie zákonných povinností, najmä účtovných a daňových: čl. 6 ods. 1 písm. c) GDPR',
            'ochrana webu, prevencia zneužitia a evidencia technických logov: čl. 6 ods. 1 písm. f) GDPR, oprávnený záujem na bezpečnosti a prevádzke webu',
            'analytické meranie návštevnosti pomocou Google Analytics 4: čl. 6 ods. 1 písm. a) GDPR, teda Váš súhlas',
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Komu môžu byť údaje sprístupnené">
        <p>
          Údaje nesprístupňujem verejne a neposkytujem ich tretím stranám bez
          dôvodu. Môžu ich však spracúvať vybraní sprostredkovatelia alebo príjemcovia,
          ak je to potrebné na fungovanie webu a komunikácie.
        </p>
        <LegalList
          items={[
            'hosting a technická infraštruktúra webu',
            'poskytovateľ e-mailových a SMTP služieb pre odosielanie a prijímanie dopytov',
            'Google Analytics 4, ak ste udelili súhlas s analytickými cookies',
            'prípadní technickí alebo právni poradcovia, ak je to potrebné na správu webu, bezpečnosť alebo ochranu práv',
          ]}
        />
      </LegalSection>

      <LegalSection title="5. Prenos do tretích krajín">
        <p>
          Ak udelíte súhlas s analytickými cookies, môže dochádzať k spracúvaniu
          údajov prostredníctvom služieb Google. To môže v nevyhnutnom rozsahu zahŕňať
          aj prenos mimo Európskej únie alebo EHP, najmä do USA.
        </p>
        <p>
          Takéto prenosy sa opierajú o mechanizmy, ktoré Google deklaruje pre
          prenos údajov, napríklad štandardné zmluvné doložky alebo iný relevantný
          mechanizmus podľa aktuálneho právneho rámca.
        </p>
      </LegalSection>

      <LegalSection title="6. Doba uchovávania">
        <LegalList
          items={[
            'dopyty a bežná komunikácia: spravidla 12 mesiacov od poslednej komunikácie, ak sa z nich nestane zmluvný vzťah',
            'zmluvná, projektová, účtovná a daňová dokumentácia: počas trvania spolupráce a následne po dobu vyžadovanú príslušnými právnymi predpismi',
            'technické logy a bezpečnostné záznamy: po dobu nevyhnutnú na prevádzku, ochranu a riešenie incidentov',
            'analytické cookies: podľa Vášho súhlasu a podľa nastavenia konkrétnych cookies, spravidla do 2 rokov',
          ]}
        />
      </LegalSection>

      <LegalSection title="7. Vaše práva">
        <p>
          Ako dotknutá osoba máte najmä právo požadovať prístup k osobným údajom,
          opravu, vymazanie, obmedzenie spracúvania, namietať proti spracúvaniu,
          odvolať súhlas a v relevantných prípadoch aj právo na prenosnosť údajov.
        </p>
        <p>
          Ak sa domnievate, že s Vašimi údajmi nenakladám v súlade s právnymi
          predpismi, môžete podať sťažnosť na Úrad na ochranu osobných údajov Slovenskej republiky.
        </p>
      </LegalSection>

      <LegalSection title="8. Ako si uplatníte práva alebo ma kontaktujete">
        <p>
          V otázkach ochrany osobných údajov ma môžete kontaktovať na e-mailovej
          adrese <strong>{LEGAL_EMAIL}</strong> alebo cez kontaktný formulár na webe.
        </p>
        <p>
          Na žiadosť odpoviem bez zbytočného odkladu a najneskôr v lehote, ktorú
          vyžaduje GDPR.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
